<template>
  <div>
    <base-header type="gradient-warning" class="pb-6 pb-8 pt-5 pt-md-8">
      <!-- Card stats -->
      <div class="row">
        <!-- Fundos ativos -->
        <div class="col-lg-4 d-flex align-items-stretch">
          <stats-card
            title="Fundos de investimentos ativos"
            type="gradient-red"
            :sub-title="String(stats.regularFunds)"
            icon="ni ni-money-coins"
            class="mb-4 mb-xl-0 flex-grow-1"
          >
            <template slot="footer">
              <span class="text-wrap">
                de um total de
                <base-dropdown>
                  <span slot="title" class="dropdown-toggle">
                    <span class="font-weight-bold text-warning">{{
                      stats.totalFunds
                    }}</span>
                    fundos
                  </span>
                  <span class="dropdown-item"
                    >Aceleração:
                    <span class="font-weight-bold rounded border py-1 px-2">{{
                      stats.fundTypes["Aceleração"] || 0
                    }}</span></span
                  >
                  <span class="dropdown-item"
                    >Pré-aceleração:
                    <span class="font-weight-bold rounded border py-1 px-2">{{
                      stats.fundTypes["Pré-aceleração"] || 0
                    }}</span></span
                  >
                  <span class="dropdown-item"
                    >Misto:
                    <span class="font-weight-bold rounded border py-1 px-2">{{
                      stats.fundTypes["Misto"] || 0
                    }}</span></span
                  >
                </base-dropdown>
              </span>
            </template>
          </stats-card>
        </div>
        <!-- Batches por fundo -->
        <div class="col-lg-4 d-flex align-items-stretch">
          <stats-card
            title="Média de batches por fundo"
            type="gradient-green"
            :sub-title="String(stats.currentBatchesAvg)"
            icon="fas fa-award"
            class="mb-4 mb-xl-0 flex-grow-1"
          >
            <template slot="footer">
              <span class="text-wrap"
                >de uma média esperada de
                <span class="font-weight-bold text-warning">{{
                  stats.expectedBatchesAvg
                }}</span>
                batches</span
              >
            </template>
          </stats-card>
        </div>
        <!-- Investidores por fundo -->
        <div class="col-lg-4 d-flex align-items-stretch">
          <stats-card
            title="Média de investidores por fundo"
            type="gradient-dark"
            :sub-title="String(stats.currentInvestorsAvg)"
            icon="fas fa-user-tie"
            class="mb-4 mb-xl-0 flex-grow-1"
          >
            <template slot="footer">
              <span class="text-wrap"
                >de uma média esperada de
                <span class="font-weight-bold text-warning">{{
                  stats.expectedInvestorsAvg
                }}</span>
                investidores</span
              >
            </template>
          </stats-card>
        </div>
      </div>
    </base-header>

    <div class="container-fluid mt--7">
      <div class="row">
        <div class="col">
          <fundos-table
            title="Fundos de investimentos STARS"
            @calculatedStats="updateStats"
          ></fundos-table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import FundosTable from "./Fundos/FundosTable";
export default {
  name: "fundos",
  components: {
    FundosTable,
  },
  data() {
    return {
      stats: {
        totalFunds: 0,
        regularFunds: 0,
        fundTypes: {},
        expectedBatchesAvg: 0,
        expectedInvestorsAvg: 0,
        currentBatchesAvg: 0,
        currentInvestorsAvg: 0,
      },
    };
  },
  methods: {
    updateStats(stats) {
      Object.assign(this.stats, stats);
    },
  },
};
</script>
<style></style>
